module.exports = {
      id: "icon-rectangle-group-30-usage",
      viewBox: "0 0 119 158",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-rectangle-group-30",
      toString: function () {
        return this.url;
      }
    }